import type { FC } from 'react';
import { Stack } from '@mui/material';

import FollowUpIcon from 'src/assets/svg/followupinspirations/FollowUpIcon.svg?react';

export const FI_HEADER_MOBILE_TEST_ID = 'fi-header-mobile';

export const FIHeaderMobile: FC = () => (
  <Stack
    direction="row"
    data-test-id={FI_HEADER_MOBILE_TEST_ID}
    sx={{
      justifyContent: 'center',
      height: '100%',
    }}
  >
    <FollowUpIcon fill="black" height="100%" width="auto" />
  </Stack>
);

export default FIHeaderMobile;
